<template>
  <v-card>
    <v-container fluid>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xl6 lg6 md6 sm6 hidden-xs-only>
          <v-btn flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xl6 lg6 md6 sm6 xs12 text-lg-right>
          <v-text-field
            style="padding:0px; margin:0px"
            id="searchBox"
            single-line
            v-model="searchValue"
            @keydown.enter="enter"
            placeholder="Buscar"
            append-icon="search"
            light
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider style="margin:0px"></v-divider>
    <v-card-text style="padding-top:15px" class="text-xs-center">
      <div class="row">
        <div class="col-md-12">
            <span class="cut-text">
                Políticas : <span style="textWeight: bold">A</span>=Factura no Pagada | B=Cuota Inicial Impaga | C=Pagaré no entregadado | D=Ramo Inactivo | E=Depuración Cartera | F=Formulario de Vinculación no Entregado por Cliente
            </span>
        </div>
      </div>
    </v-card-text>
    <v-card-text style="padding-top:0px">
      <v-data-table
        flat
        select-all
        v-bind:pagination.sync="pagination"
        item-key="id"
        v-model="selected"
        :items="commissionsVisualize"
        :headers="headers"
        class="v-table-list compact theme--light"
        :rows-per-page-text="$t('message.rowsByPage')"
      >
        <template slot="headers" scope="props">
          <tr class="border-buttom">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <span v-if="header.text">{{ header.text }}</span>
              <div class="text-xs-center" v-if="header.html" v-html="header.html"></div>
              <v-icon>arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
             <td class="text-xs-left cut-text">{{ props.item.agency }}</td>
            <td
              class="text-xs-left cut-text"
            >{{typeof props.item.type=='undefined'?'Factura':props.item.type}}</td>
            <td class="text-xs-left cut-text">{{ props.item.receipt }}</td>
            <td class="text-xs-left cut-text">{{ props.item.businessLine }}</td>
            <td class="text-xs-left cut-text">{{ props.item.policy }}</td>
            <td class="text-xs-left cut-text">{{ props.item.annex }}</td>
            <td class="text-xs-left cut-text">{{ props.item.product}}</td>
            <td class="text-xs-left cut-text">{{ props.item.endorsement }}</td>
            <td class="text-xs-left cut-text">{{ props.item.quoteNumber }}</td>
            <td class="text-xs-left cut-text">{{ props.item.date }}</td>
            <td class="text-xs-left cut-text">{{ props.item.clientCode }}</td>
            <td class="text-xs-left cut-text">{{ props.item.clientName }}</td>
            <td
              class="text-xs-left cut-text"
              v-if="!isNaN(props.item.premium)"
            >{{ props.item.premium | currency }}</td>
            <td class="text-xs-left cut-text" v-else>{{0.00 |currency}}</td>
            <td
              class="text-xs-left cut-text"
              v-if="!isNaN(props.item.commissionVal)"
            >{{ props.item.commissionVal | currency }}</td>

            <td class="text-xs-left cut-text" v-else>{{0.00 |currency}}</td>

            <td
              class="text-xs-left cut-text"
              v-if="!isNaN(props.item.value)"
            >{{ props.item.value |currency}}</td>
            <td class="text-xs-left cut-text" v-else>{{0.00 |currency}}</td>
            <td class="text-xs-left cut-text">{{props.item.politics}}</td>

            <!--  variables adjusment y creditNotes -->
          </tr>
        </template>
        <template slot="no-data">
          <div>{{$t('message.noPreliquidations')}}</div>
        </template>

        <template
          slot="pageText"
          slot-scope="props">
              {{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

export default {
  computed: {
    ...mapGetters(["loadingCommission", "commissionsVisualize", "agency"])
  },
  mounted() {
    this.$store.dispatch("getCommissionsVisualize");
  },
  methods: {
    nzDate: nzDate,
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.commissionsVisualize.slice();
      }
      this.$store.dispatch("updateCommissionSelected", this.selected);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    refresh() {
      if (this.searchValue != "") {
        this.$store.dispatch("getCommissionsVisualize", this.searchValue);
      } else {
        // console.log("vacio");
        this.$store.dispatch("getCommissionsVisualize");
      }
    },
    enter() {
      if (this.searchValue != "") {
        this.$store.dispatch("getCommissionsVisualize", this.searchValue);
      } else {
        // console.log("vacio");
        this.$store.dispatch("getCommissionsVisualize");
      }
    }
  },
  watch: {
    loadingCommission(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    selected(val) {
      this.$store.dispatch("updateCommissionSelected", val);
    },
    agency(val) {
      this.$store.dispatch("getCommissionsVisualize");
    }
  },
  data() {
    return {
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: ""
      },
      selected: [],
      headers: [
          {
          align: "left",
          sortable: true,
          text: i18n.t("message.agency"),
          value: "type",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.type"),
          value: "type",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.document"),
          value: "receipt",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.bunch"),
          value: "businessLine",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.policy"),
          value: "policy",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.certificate"),
          value: "annex",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.product"),
          value: "product",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.endorsement"),
          value: "endorsement",
          width: "1%"
        },

        {
          align: "left",
          sortable: true,
          text: i18n.t("message.numFee"),
          value: "quoteNumber",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.paymentDate"),
          value: "date",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.identification"),
          value: "clientCode",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.clientName"),
          value: "clientName",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.premiumValue"),
          value: "premium",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.commission"),
          value: "commissionVal",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.loan"),
          value: "value",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          html:
            i18n.t("message.policies") +
            "<br/>Est. | &nbsp;A &nbsp;| &nbsp;B&nbsp; | &nbsp;C&nbsp; | &nbsp;D&nbsp; | &nbsp;E&nbsp; | &nbsp;F&nbsp; |",
          value: "uglyPolitics",
          width: "1%"
        }
      ]
    };
  }
};
</script>